/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggers } from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggers';

/**
 * 
 * @export
 * @interface UpdateIntegrationsConfigRequestTehtris
 */
export interface UpdateIntegrationsConfigRequestTehtris {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    apiKey?: string;
    /**
     * 
     */
    customerName: string;
    /**
     * 
     */
    appliance: string;
    /**
     * 
     */
    region: UpdateIntegrationsConfigRequestTehtrisRegionEnum;
    /**
     * 
     */
    defaultStatusId: string;
    /**
     * 
     */
    triggers: GetIntegrationsConfig200ResponseTehtrisTriggers;
}


/**
 * @export
 */
export const UpdateIntegrationsConfigRequestTehtrisRegionEnum = {
    Xjc: 'xjc',
    Xjd: 'xjd',
    Xje: 'xje',
    Xjf: 'xjf',
    Xjg: 'xjg',
} as const;
export type UpdateIntegrationsConfigRequestTehtrisRegionEnum = typeof UpdateIntegrationsConfigRequestTehtrisRegionEnum[keyof typeof UpdateIntegrationsConfigRequestTehtrisRegionEnum];


/**
 * Check if a given object implements the UpdateIntegrationsConfigRequestTehtris interface.
 */
export function instanceOfUpdateIntegrationsConfigRequestTehtris(value: object): value is UpdateIntegrationsConfigRequestTehtris {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('customerName' in value) || value['customerName'] === undefined) return false;
    if (!('appliance' in value) || value['appliance'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('defaultStatusId' in value) || value['defaultStatusId'] === undefined) return false;
    if (!('triggers' in value) || value['triggers'] === undefined) return false;
    return true;
}

export function UpdateIntegrationsConfigRequestTehtrisFromJSON(json: any): UpdateIntegrationsConfigRequestTehtris {
    return UpdateIntegrationsConfigRequestTehtrisFromJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestTehtrisFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIntegrationsConfigRequestTehtris {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
        'customerName': json['customerName'],
        'appliance': json['appliance'],
        'region': json['region'],
        'defaultStatusId': json['defaultStatusId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json['triggers']),
    };
}

export function UpdateIntegrationsConfigRequestTehtrisToJSON(json: any): UpdateIntegrationsConfigRequestTehtris {
    return UpdateIntegrationsConfigRequestTehtrisToJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestTehtrisToJSONTyped(value?: UpdateIntegrationsConfigRequestTehtris | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'apiKey': value['apiKey'],
        'customerName': value['customerName'],
        'appliance': value['appliance'],
        'region': value['region'],
        'defaultStatusId': value['defaultStatusId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(value['triggers']),
    };
}

